"use strict";
/*
    Copyright 2019 Dynatrace LLC

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.KAFKA = exports.TIBCO = exports.MQSERIES = exports.MQSERIES_JMS = exports.WEBSPHERE = exports.ARTEMIS = exports.RABBIT_MQ = exports.ACTIVE_MQ = exports.HORNETQ = void 0;
/**
 * Constants for well known database vendors. May be used in MessagingSystemInfo.
 */
exports.HORNETQ = "HornetQ";
exports.ACTIVE_MQ = "ActiveMQ";
exports.RABBIT_MQ = "RabbitMQ";
exports.ARTEMIS = "Artemis";
exports.WEBSPHERE = "WebSphere";
exports.MQSERIES_JMS = "MQSeries JMS";
exports.MQSERIES = "MQSeries";
exports.TIBCO = "Tibco";
exports.KAFKA = "Apache Kafka";
